import React from "react";
interface CaratProps {
  direction?: "up" | "down";
  color?: string;
  size?: number;
}
export default function Carat({
  direction = "down",
  color = "#424242",
  size = 3.5,
}: CaratProps) {
  return (
    <div className="inline-block relative">
      {direction === "up" ? (
        <div
          style={{
            borderBottom: `${size * 2}px solid ${color}`,
            borderLeft: `${size}px solid transparent`,
            borderRight: `${size}px solid transparent`,
          }}
          className={`ml-2 w-0 h-0`}
        ></div>
      ) : (
        <div
          style={{
            borderTop: `${size * 2}px solid ${color}`,
            borderLeft: `${size}px solid transparent`,
            borderRight: `${size}px solid transparent`,
          }}
          className={`ml-2 w-0 h-0`}
        ></div>
      )}
    </div>
  );
}
